import { createSelector } from 'reselect';

const selectAnnouncements = (state: any) => state.announcements;


export const selectAnnouncementsCurrentItem = createSelector([selectAnnouncements], (announcements) => announcements.current);

export const selectAnnouncementsListItems = createSelector([selectAnnouncements], (announcements) => announcements.list);

export const selectAnnouncementsItemById = (itemId: any) =>
    createSelector(selectAnnouncementsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAnnouncementsQueryItems = createSelector([selectAnnouncements], (announcements) => announcements.query);

export const selectAnnouncementsCreatedItem = createSelector([selectAnnouncements], (announcements) => announcements.create);

export const selectAnnouncementsUpdatedItem = createSelector([selectAnnouncements], (announcements) => announcements.update);

export const selectAnnouncementsReadItem = createSelector([selectAnnouncements], (announcements) => announcements.read);

export const selectAnnouncementsDeletedItem = createSelector([selectAnnouncements], (announcements) => announcements.delete);

export const selectAnnouncementsSearchedItems = createSelector([selectAnnouncements], (announcements) => announcements.search);

export const selectAnnouncementsItemsCount = createSelector([selectAnnouncements], (announcements) => announcements.count);

export const selectAnnouncementsItemsFilter = createSelector([selectAnnouncements], (announcements) => announcements.filter);